export default __webpack_public_path__ + "static/visa-35f1d17871ced3fbbfc75f8b92d5fee2.png";